export const FEATURE_FLAGS = {
  AGENT_BOTS: 'agent_bots',
  // Ellie Desk: email spam filtering + junk folder
  EMAIL_SPAM_FILTERING: 'email_spam_filtering',
  // Ellie Desk: customer-context sidebar panel (Stripe/PostHog/Ellie account data)
  CUSTOMER_CONTEXT: 'customer_context',
  AGENT_MANAGEMENT: 'agent_management',
  ASSIGNMENT_V2: 'assignment_v2',
  ADVANCED_ASSIGNMENT: 'advanced_assignment',
  AUTO_RESOLVE_CONVERSATIONS: 'auto_resolve_conversations',
  AUTO_TRANSLATE: 'auto_translate',
  AUTOMATIONS: 'automations',
  CAMPAIGNS: 'campaigns',
  CAMPAIGN_ANALYTICS: 'campaign_analytics',
  WHATSAPP_EMBEDDED_SIGNUP_FLOW: 'whatsapp_embedded_signup_inbox_creation',
  WHATSAPP_MANUAL_TRANSFER: 'whatsapp_manual_transfer',
  CANNED_RESPONSES: 'canned_responses',
  CRM: 'crm',
  CUSTOM_ATTRIBUTES: 'custom_attributes',
  DATA_IMPORT: 'data_import',
  DELAYED_AUTOMATIONS: 'delayed_automations',
  API_AND_WEBHOOKS: 'api_and_webhooks',
  INBOX_MANAGEMENT: 'inbox_management',
  INTEGRATIONS: 'integrations',
  LABELS: 'labels',
  MACROS: 'macros',
  HELP_CENTER: 'help_center',
  REPORTS: 'reports',
  CONVERSATION_MONITORS: 'conversation_monitors',
  TEAM_MANAGEMENT: 'team_management',
  VOICE_RECORDER: 'voice_recorder',
  AUDIT_LOGS: 'audit_logs',
  AUDIT_LOG_IP_ADDRESS: 'audit_log_ip_address',
  INBOX_VIEW: 'inbox_view',
  SLA: 'sla',
  CHANNEL_EMAIL: 'channel_email',
  CHANNEL_FACEBOOK: 'channel_facebook',
  CHANNEL_WEBSITE: 'channel_website',
  CUSTOM_REPLY_DOMAIN: 'custom_reply_domain',
  CUSTOM_REPLY_EMAIL: 'custom_reply_email',
  DISABLE_BRANDING: 'disable_branding',
  EMAIL_CONTINUITY_ON_API_CHANNEL: 'email_continuity_on_api_channel',
  INBOUND_EMAILS: 'inbound_emails',
  IP_LOOKUP: 'ip_lookup',
  LINEAR: 'linear_integration',
  SHOPIFY: 'shopify_integration',
  STRIPE: 'stripe_integration',
  CAPTAIN: 'captain_integration',
  CUSTOM_ROLES: 'custom_roles',
  CHATWOOT_V4: 'chatwoot_v4',
  CHANNEL_INSTAGRAM: 'channel_instagram',
  CHANNEL_TIKTOK: 'channel_tiktok',
  CHANNEL_VOICE: 'channel_voice',
  MOBILE_VOICE_PUSH: 'mobile_voice_push',
  CONTACT_CHATWOOT_SUPPORT_TEAM: 'contact_chatwoot_support_team',
  CAPTAIN_CUSTOM_TOOLS: 'custom_tools',
  CAPTAIN_TASKS: 'captain_tasks',
  CAPTAIN_CLASSIFIER: 'captain_classifier',
  CAPTAIN_DOCUMENT_AUTO_SYNC: 'captain_document_auto_sync',
  COPILOT_WORKFLOWS: 'copilot_workflows',
  SAML: 'saml',
  COMPANIES: 'companies',
  COMPANY_ENRICHMENT: 'company_enrichment',
  ADVANCED_SEARCH: 'advanced_search',
  CONVERSATION_REQUIRED_ATTRIBUTES: 'conversation_required_attributes',
  CONVERSATION_UNREAD_COUNTS: 'conversation_unread_counts',
  UNREAD_COUNT_FOR_FILTERS: 'unread_count_for_filters',
};

export const PREMIUM_FEATURES = [
  FEATURE_FLAGS.CAMPAIGN_ANALYTICS,
  FEATURE_FLAGS.SLA,
  FEATURE_FLAGS.CAPTAIN,
  FEATURE_FLAGS.CAPTAIN_CUSTOM_TOOLS,
  FEATURE_FLAGS.CUSTOM_ROLES,
  FEATURE_FLAGS.AUDIT_LOGS,
  FEATURE_FLAGS.HELP_CENTER,
  FEATURE_FLAGS.SAML,
  FEATURE_FLAGS.CONVERSATION_REQUIRED_ATTRIBUTES,
  FEATURE_FLAGS.ADVANCED_ASSIGNMENT,
  FEATURE_FLAGS.COMPANY_ENRICHMENT,
];

// Paywalled on Chatwoot Cloud only; free on self-hosted installs.
export const CLOUD_PAYWALLED_FEATURES = [FEATURE_FLAGS.COMPANIES];
